// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1Oa5o","dragIcon":"SortableItem_dragIcon__3Zpg8","disabled":"SortableItem_disabled__EQXBl"};